module.exports = __webpack_public_path__ + "img/1523327083.5cfee3fe.jpg";